import axios from 'axios';

const api = axios.create();

async function postRefreshToken(error) {
  return new Promise((resolve, reject) => {
    try {
      const token = localStorage.getItem('@Braspress:token');
      const refreshToken = localStorage.getItem('@Braspress:refreshToken');
      const deviceId = localStorage.getItem('@Braspress:deviceId');

      const body = {
        token,
        refreshToken,
        deviceId
      };

      axios
        .post(
          `${process.env.REACT_APP_URL_MS_AUTH}/api/v1/auth/refresh-token`,
          body
        )
        .then(async (res) => {
          localStorage.setItem('@Braspress:token', res.data.data.token);
          localStorage.setItem(
            '@Braspress:refreshToken',
            res.data.data.refreshToken
          );
          return resolve(res);
        })
        .catch((err) => {
          return reject(error);
        });
    } catch (err) {
      return reject(err);
    }
  });
}

api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    const token = localStorage.getItem('@Braspress:token');

    if (error.response.status === 401 && !originalRequest._retry && token) {
      originalRequest._retry = true;
      try {
        const response = await postRefreshToken(error);

        if (response.status === 200) {
          originalRequest.headers.Authorization = `Bearer ${response.data.data.token}`;
        }

        return api(originalRequest);
      } catch (err) {
        return error;
      }
    } else if (
      ((error.response.status === 400 ||
        error.response.status === 401 ||
        error.response.status === 403 ||
        error.response.status === 500) &&
        originalRequest._retry &&
        token) ||
      ((error.response.status === 400 ||
        error.response.status === 401 ||
        error.response.status === 403 ||
        error.response.status === 500) &&
        String(error.config.url).includes('auth/refresh-token') &&
        token)
    ) {
      localStorage.removeItem('@Braspress:token');
      localStorage.removeItem('@Braspress:refreshToken');
      localStorage.removeItem('@Braspress:legacyToken');
      localStorage.removeItem('@Braspress:deviceId');
      localStorage.removeItem('@Braspress:user');
      localStorage.removeItem('@Braspress:userAddressList');
      localStorage.removeItem('@Braspress:userContactList');
      window.location.pathname = `${process.env.REACT_APP_URL_CLIENT_VIEW}${process.env.REACT_APP_URL_BOTAO_VOLTAR}`;
    }
    return Promise.reject(error);
  }
);

export default api;
